import React, { Component } from 'react';
import { hideModal, MODAL_USERS_ROOMS } from '../../../../modules/modals';

import { connect } from 'react-redux'
import Modal from 'react-modal';
import PropTypes from 'prop-types'
import {toastr} from 'react-redux-toastr'
import { Table } from 'antd';

class UsersModal extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  handleClose = () => {
    const { hideModal } = this.props;
    hideModal({ modalType : MODAL_USERS_ROOMS});
  }

  getTitle = () => {
    const {formatMessage} = this.context
    let text = "frmTitleUsersRoom"
    return <div className="create-dialog-modal-content__title">{formatMessage(text)}</div>;
  }

  render() {
    const {formatMessage} = this.context
    const { zIndex, students } = this.props;

    const columns = [
      {
        title: formatMessage('tableStudentFirstName'),
        dataIndex: 'firstname',
        key: 'firstname',
      },
      {
        title: formatMessage('tableStudentLastName'),
        dataIndex: 'lastname',
        key: 'lastname',
      },
      {
        title: formatMessage('tableStudentEmail'),
        dataIndex: 'email',
        key: 'email',
      },
    ];

    return (
      <Modal
          isOpen = {true}
          style = {{
              overlay : {zIndex},
          }}
          onRequestClose={this.handleClose}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content StudensRoomModal"
      >
          <div className="create-dialog-modal-content__header">
              {
                this.getTitle()
              }
              <div
                  onClick={this.handleClose}
                  className="create-dialog-modal-content__close"
              ></div>
          </div>
          <div className="create-dialog-modal-content__body">
            <form className="create-dialog-form">
              <div className="row mb-5">
              <Table
                dataSource={students}
                columns={columns}
                bordered
                pagination={false}
                scroll={{ y: 400 }}
              />
              </div>
              <div className="create-dialog-form__group flex">
                <button className="btn btn-warning mr-auto" type="button" onClick={() => {
                  this.handleClose();
                }}>{formatMessage('btnModalCancelUsersRoom')}</button>
              </div>
            </form>
          </div>
      </Modal>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({
})

const mapDispatchToProps = {
  hideModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersModal)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Quizs/components/Room/UsersModal.jsx